export const FormValidationEvent = {
  SHOW_REQUIRED_FIELDS: 'FormValidationEvent:SHOW_REQUIRED_FIELDS',
  HIDE_REQUIRED_FIELDS: 'FormValidationEvent:HIDE_REQUIRED_FIELDS'
};
